var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYouTubePlaylistGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7 14.3142C34.7 14.3142 34.4066 12.3548 33.5075 11.492C32.4783 10.47 31.337 10.3655 30.6932 10.3066C30.6233 10.3002 30.5593 10.2943 30.5019 10.2879C26.3037 10 20.0066 10 20.0066 10H19.9934C19.9934 10 13.6963 10 9.49813 10.2879C9.44073 10.2943 9.37671 10.3002 9.30686 10.3066C8.66259 10.3655 7.52175 10.4698 6.49157 11.492C5.5925 12.3548 5.3 14.3142 5.3 14.3142C5.3 14.3142 5 16.6157 5 18.9163V21.0739C5 23.3754 5.3 25.676 5.3 25.676C5.3 25.676 5.5925 27.6354 6.49157 28.4982C7.43891 29.4382 8.63211 29.5739 9.39233 29.6603C9.54844 29.678 9.68628 29.6937 9.8 29.7139C12.2 29.9325 20 30 20 30C20 30 26.3037 29.9911 30.5019 29.7032C30.5599 29.6966 30.6248 29.6906 30.6956 29.684C31.3399 29.6244 32.4796 29.519 33.5075 28.4982C34.4066 27.6354 34.7 25.676 34.7 25.676C34.7 25.676 35 23.3754 35 21.0739V18.9163C35 16.6157 34.7 14.3142 34.7 14.3142ZM17 25.1962L26 20L17 14.8038V25.1962Z",
    fill: "white"
  })));
}

export default SvgYouTubePlaylistGlyph;